import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { VaultItemDTO } from '../../types';
import { createColouredGlassSurface, createParchmentLabelSurface, hashStringToSeed } from '../../theme/surfaces';
import { PotionCard } from './PotionCard';

interface PotionMiniCardProps {
  item: VaultItemDTO;
  memberNameById: Map<string, string>;
  onDiscard: (instanceId: string) => void;
  onSell?: (instanceId: string) => void;
}

export const PotionMiniCard: React.FC<PotionMiniCardProps> = React.memo(function PotionMiniCard({
  item,
  memberNameById,
  onDiscard,
  onSell,
}) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const surfaceSx = React.useMemo(
    () => ({ ...createColouredGlassSurface(hashStringToSeed(item.id))}),
    [item.id],
  );

  const parchmentLabelSx = React.useMemo(
    () => createParchmentLabelSurface(hashStringToSeed(item.id)),
    [item.id],
  );

  return (
    <Box sx={{ ...surfaceSx, width: 270, '&::before': { display: 'none' }, '&::after': { display: 'none' } }} p={1.5}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <Box sx={{ ...parchmentLabelSx, maxWidth: '70%' }}>
          <Typography variant="subtitle2">{item.name}</Typography>
        </Box>
        <IconButton
          size="small"
          onClick={() => setIsExpanded(true)}
          aria-label={`Expand ${item.name}`}
          sx={{ position: 'absolute', top: 0, right: 0 }}
        >
          <OpenInFullIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <Dialog open={isExpanded} onClose={() => setIsExpanded(false)} maxWidth="sm" className="MemberDialog" sx={{ m: 0, p: 0, border: 0 }}>
        <DialogContent sx={{ m: 1, p: 0 }}>
          <PotionCard
            item={item}
            memberNameById={memberNameById}
            onDiscard={(instanceId) => { setIsExpanded(false); onDiscard(instanceId); }}
            onSell={onSell}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsExpanded(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
});
